module.exports = __webpack_public_path__ + "static/media/log.fc7be7f2.svg";